/*	
	App configuration file

	Date created: 3/9/2021; Last Update: 4/16/2021

	Although this App is by itself (or beyond en and tc),
	but as of 1/23/2021 it's attached to en site. So the site url is en.

	This Configuration file will not be just for the frontend app form,
	but also to be used for the backend once backend
	(Tablets Manager for the staff) is also handled by React.(2/5/2021)

	prod site:
	const mainSiteLink = "https://www.baus.org";
	aboutUsLink: "https://www.baus.org/en/about-us/",
	contactUsLink: "https://www.baus.org/en/about-us/contact-us/"

	dev site:
	const mainSiteLink = "https://baus.ilotus.org";
	aboutUsLink: "https://baus.ilotus.org/en/about-us/",
	contactUsLink: "https://baus.ilotus.org/en/about-us/contact-us/"

	local site:
	const mainSiteLink = "http://localhost/baus";
	aboutUsLink: "http://localhost/baus/en/about-us/",
	contactUsLink: "http://localhost/baus/en/about-us/'contact-us/"

*/

const mainSiteLink = "https://www.baus.org";
//const mainSiteLink = "https://baus.ilotus.org";
//const mainSiteLink = "http://localhost/baus";

const appConfig = {
	siteSet: {
		title: "BAUS",
		titleC: "美國佛教會",
		link: mainSiteLink + "/en",
		startYear: '1996'
	},

	pageSet: {
		aboutUsLink: mainSiteLink + "/en/about-us/",
		contactUsLink: mainSiteLink + "/en/about-us/contact-us/",
		servicesLink: mainSiteLink + "/en/about-us/services/"
	},

	appSet: {
		title: "Longevity Light App Form",
		titleC: "消災延壽光明燈登記表",
		link: mainSiteLink + "/gmd",
		contactEmail: 'programs@baus.org',
		contactPhone: '(845)225-1819',
		checkLightURL: mainSiteLink + "/gmd/gmd_app_check_light_num.php"
	},

	formSet: {
		title: "Longevity Light prayer for health and prosperity",
		titleC: "消災延壽光明燈登記表",
		title2: "Longevity Light",
		title2C: "消災延壽光明燈",
		link: mainSiteLink + "/gmd"
	},

	donorInfo: [
		['中名', 'Chinese Name'],
		['英名', 'English Name'],
		['手機', 'Cell Phone'],
		['座機', 'Home Phone'],
		['電郵', 'Email'],
		['性別', 'Sex'],
		['地址', 'Address'],
		['城市', 'City'],
		['州別', 'State'],
		['區碼', 'Zip Code']
	],
};

export default appConfig;
